import axios from 'axios'

/**
 * A plain axios client for `/ajax/*` calls that must work for a signed-out
 * guest — no `AxiosContext`, so none of its side effects (toast + logout +
 * redirect to `/login` on an "inactive user" response) fire. Still sends
 * cookies (`withCredentials`), so a logged-in viewer gets the same response
 * a real session would produce; the backend's own `isAllowed()` checks are
 * what actually gate private data, not this client's auth state.
 */
export function createAnonymousApi() {
  return axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    withCredentials: true,
    timeout: 60000,
  })
}
